import { render, staticRenderFns } from "./SnsEndpointView.vue?vue&type=template&id=6e9c2860&scoped=true&"
import script from "./SnsEndpointView.vue?vue&type=script&lang=ts&"
export * from "./SnsEndpointView.vue?vue&type=script&lang=ts&"
import style0 from "./SnsEndpointView.vue?vue&type=style&index=0&id=6e9c2860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c2860",
  null
  
)

export default component.exports